import { DefaultTheme, ThemeProps } from 'styled-components';

/**
 * On desktop, this returns a selector which will never match anything, while on mobile
 * it returns a selector which always matches everything.
 *
 * Do not use this inside of styled-components.
 * Instead, use the Breakpoints enum constant
 */
export const onMobile = ({ theme }: ThemeProps<DefaultTheme>) =>
  // Only treat this as desktop if there is a theme which explicitly says so
  theme?.screenSize === 'desktop' ? '&.mobile-only' : '&';
